import { NewsItem, NewsType } from '../../../services/newsService/newsService.interface'
import { NewsTrackingIds, NewsTrackingText, ViewNewsItem } from './M_NewsTabs.interface'
import { createTealiumTracking, MsTracking, NOT_SET, TrackingParameter, MLM } from '@sunrise/tracking'
import type { URL } from 'url'

const TEXT_TYPE_POLICE = 'Polizeimeldungen_Klick'
const TEXT_BODY = 'text_body'
const NATIVE = 'native'

export function getNewsTracking(newsItem: ViewNewsItem, currentUrl: URL): MsTracking[] | null {
    const trackingParameter = getNewsTrackingParameter(newsItem)
    const clickTracking = trackingParameter && [createTealiumTracking(trackingParameter)]

    if (newsItem.type && clickTracking && isRssFeed(newsItem.type)) {
        clickTracking.push(createMlmClickTracking(newsItem, currentUrl))
    }

    return clickTracking
}

function isRssFeed(newsType: NewsType) {
    return newsType === NewsType.RSS
}

function isPolice(newsType: NewsType) {
    return newsType === NewsType.POLICE
}

function getNewsTrackingParameter({ type, position, provider }: ViewNewsItem): TrackingParameter | null {
    if (!type) {
        return null
    }

    return {
        mslayer_element_data_id: getDataIdBy(type),
        mslayer_element_text: getTextBy(type),
        mslayer_element_type_text: getTextTypeBy(type),
        mslayer_element_count: NOT_SET,
        mslayer_element_variant: getVariantBy(type),
        mslayer_element_body_type: TEXT_BODY,
        mslayer_element_position: getPositionAsString(position ? position : null),
        mslayer_element_id: NOT_SET,
        mslayer_affiliate_id: NOT_SET,
        mslayer_element_company_name: isRssFeed(type) ? normalizeSource(provider, '') : NOT_SET,
        mslayer_element_detail_start_date: NOT_SET,
    }
}

function getDataIdBy(newsType: NewsType) {
    return isPolice(newsType) ? NewsTrackingIds.CLICK_NEWS_POLICE : NewsTrackingIds.CLICK_NEWS_RSS
}

function getTextBy(newsType: NewsType) {
    return isPolice(newsType) ? NewsTrackingText.POLICE : NewsTrackingText.RSS
}

function getTextTypeBy(newsType: NewsType) {
    return isPolice(newsType) ? TEXT_TYPE_POLICE : NOT_SET
}

function getVariantBy(newsType: NewsType): string {
    return isPolice(newsType) ? NOT_SET : NATIVE
}

function getPositionAsString(position: number | null): string {
    return position ? position.toString() : NOT_SET
}

export function createMlmClickTracking(item: ViewNewsItem, currentUrl: URL) {
    return MLM.createMlmTracking(
        buildMlmTracking(
            MLM.ActionId.CLICK,
            [
                {
                    id: item?.id.toString(),
                    type: normalizeSource(item.provider, ''),
                    typePaid: 'standard',
                    typePosition: item.position ? item.position : 0,
                },
            ],
            currentUrl.toString(),
        ),
    )
}

export function mlmTrackViews(items: NewsItem[], currentUrl: string) {
    const mlmItems = items.map((item, index) => {
        return {
            id: item.id.toString(),
            type: normalizeSource(item.provider, ''),
            typePaid: 'standard',
            typePosition: index + 1,
        }
    })

    MLM.trackView(buildMlmTracking(MLM.ActionId.VIEW, mlmItems, currentUrl))
}

function buildMlmTracking(actionId: MLM.ActionId, items: MLM.Item[], currentUrl: string): MLM.TrackingData {
    return {
        affiliateId: 313,
        actionId,
        componentId: 'M_RssFeed_Resultlist',
        itemChannel: 'home',
        pageUrl: currentUrl.toString(),
        page: 1,
        items,
    }
}

function normalizeSource(text: string, defaultValue: string): string {
    if (!text) {
        return defaultValue
    }

    return text
        .toLowerCase()
        .replaceAll('ü', 'ue')
        .replaceAll('ö', 'oe')
        .replaceAll('ä', 'ae')
        .replace(/[^0-9a-zA-Z_]/g, '')
}
